import {
    NeosEvents,
    ButtonContextBar
} from "GesagtGetan.Basic/Resources/Private/Assets/Backend";
import { domReady } from "GesagtGetan.Basic/Resources/Private/Assets/Helper";
import Gator from "gator";
import initSwiper from "./Library";

const ContextButton = {
    check: () => !!document.getElementById("swiper-edit"),
    title: "Swiper",
    icon: "f03e",
    className: "toggle-swiper",
    toggleClass: "-swipervisible"
};

function updateSwiper() {
    setTimeout(() => {
        let elements = document.querySelectorAll(".swiper-container");
        for (let i = 0; i < elements.length; i++) {
            try {
                elements[i].swiper.update(true);
            } catch (e) {}
        }
    }, 200);
}

function startSwiper() {
    ButtonContextBar.toggle(ContextButton);
    initSwiper();
}

Gator(document).on(
    "click",
    ".toggle-swiper-empty, .swiper-type--image .swiper-slide",
    () => {
        ButtonContextBar.trigger(ContextButton);
        updateSwiper();
    }
);

Gator(document).on("click", ".toggle-swiper", updateSwiper);

domReady(startSwiper);
NeosEvents("PageLoaded,ContentModuleLoaded", startSwiper);
NeosEvents("LayoutChanged,ContentModuleLoaded", updateSwiper);
